import React, { useState } from 'react';
import Typography from '../components/v2/Typography';
import Button from '../components/v2/Button';
import { Download, ArrowRight, Search, Menu, SearchIcon, Globe, InfoIcon, CheckIcon } from 'lucide-react';
import DomainCard from '../components/v2/DomainCard';
import IButton from '../components/v2/IButton';
import Input from '../components/v2/Input';
import Textarea from '../components/v2/TextArea';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../atoms/Header';
import BlogSection from '../atoms/BlogPreview';
import ContactSection from '../atoms/Contact';
import useApp from '../hooks/useApp';

const Hero = () => {

  const appCtx = useApp();

  return (
    <section className="hero-wrapper">
      <div className="inner">
        <div className="hero-img-wrapper">
          <div className="hero-img">
            <img src="https://cdn.webstadia.com/bc924857-8f35-472e-9f4a-87d1be2ea73c.png" alt="Hero" />
          </div>
        </div>
        <div className="hero-content-wrapper">
          <div className='hero-text-content-wrapper'>
            <div className="hero-text-wrapper">
              <Typography variant="h2">Your Brand Deserves the Perfect Name</Typography>
              <Typography variant="h1">We broker top-tier domains with speed, precision, and results that speak louder than promises!</Typography>
            </div>
            <div className="hero-controls-wrapper">
              {/* Add buttons or controls here */}
              <Button isLink={true} linkProps={{to:"/contact"}} variant='primary'>
                <Typography variant={'button'}>Want to buy or sell domain?</Typography>
              </Button>
              <Button isLink={true} linkProps={{to:"/domains-for-sale"}} variant='secondary'><Typography variant={'button'}>Browse featured domains</Typography></Button>
            </div>
          </div>
          <div className='hero-featured-domains-wrapper'>
            {appCtx.heroDomainsList.slice(0, 6).map((domain, i) => {
              return (
                <DomainCard key={`${i}`} image={domain.image['thumbnail']} tag={domain.tag} domain={domain.domain} price={domain.price} hideTag={true} />
              )
            })}
          </div>
        </div>

        <div className="hero-bg-img-wrapper">
          {/* <div className='hero-bg-separator'></div> */}
        </div>

        <div className='hero-footer'>
          <div className='hero-bg-separator-new'></div>
          <Typography variant="info">NameConnect is a premium domain name brokerage, acquisition, and consulting firm. If you're a company or investor serious about your online presence, then you understand the power of a brandable and generic URL. NameConnect acquires the most relevent domains, provides brand protection, and world class web hosting. View all of our services on our domain services page.</Typography>
        </div>

      </div>
    </section>
  );
}

const FeaturedSection = () => {

  const navigateTo = useNavigate();

  const appCtx = useApp();

  const bigCards = appCtx.featuredDomainsList.filter((domain, i) => domain.card === 'big');
  const normalCards = appCtx.featuredDomainsList.filter((domain, i) => domain.card === 'small');

  return (

    <section className="featured-wrapper">
      <div className="inner">
        <div className="featured-heading">
          <span>Explore our top-performing names ready for your brand</span>
        </div>
        <div className="featured-content">
          <div className="inner">
            <div className="row row1 featured-row">
              {bigCards && bigCards.length > 0 && <div className="card card1">
                <DomainCard image={bigCards[0].image['medium']} tag={bigCards[0].tag} domain={bigCards[0].domain} price={bigCards[0].price} hideTag={false} />
              </div>}
              <div className="card card2">
                <Button variant='primary' leftIcon={Globe} rightIcon={ArrowRight}>
                  <Typography variant={'button'}>browse all domains</Typography>
                </Button>
                <Button variant='primary-2' leftIcon={SearchIcon} rightIcon={ArrowRight}>
                  <Typography variant={'button'}>appraise your domain</Typography>
                </Button>
                <Button variant='primary-2' leftIcon={InfoIcon} rightIcon={ArrowRight}>
                  <Typography variant={'button'}>talk to our team</Typography>
                </Button>
              </div>
            </div>
            {/* {normalCards && normalCards.length > 0 && <div className="row row2 normal-row">
              <div className="card card1">
                <DomainCard image={feaured_domains_list[0].image} tag={feaured_domains_list[0].tag} domain={feaured_domains_list[0].domain} price={feaured_domains_list[0].price} hideTag={false} />
              </div>
              <div className="card card2">
                <DomainCard image={feaured_domains_list[0].image} tag={feaured_domains_list[0].tag} domain={feaured_domains_list[0].domain} price={feaured_domains_list[0].price} hideTag={false} />
              </div>
            </div>}
            <div className="row row3 normal-row">
              <div className="card card1">
                <DomainCard image={feaured_domains_list[0].image} tag={feaured_domains_list[0].tag} domain={feaured_domains_list[0].domain} price={feaured_domains_list[0].price} hideTag={false} />
              </div>
              <div className="card card2">
                <DomainCard image={feaured_domains_list[0].image} tag={feaured_domains_list[0].tag} domain={feaured_domains_list[0].domain} price={feaured_domains_list[0].price} hideTag={false} />
              </div>
            </div>
             */}
            {normalCards && normalCards.length > 0 && (
              <>
                {normalCards.map((card, index) => (
                  index % 2 === 0 && (
                    <div className="row normal-row" key={index}>
                      <div className="card card1">
                        <DomainCard
                            image={(normalCards[index + 1]?.image['medium'] || normalCards[index + 1]?.image['original'] || normalCards[index + 1]?.image['thumbnail'])}
                            tag={normalCards[index]?.tag}
                          domain={normalCards[index]?.domain}
                          price={normalCards[index]?.price}
                          hideTag={false}
                        />
                      </div>
                      {normalCards[index + 1] && (
                        <div className="card card2">
                          <DomainCard
                            image={(normalCards[index + 1]?.image['medium'] || normalCards[index + 1]?.image['original'] || normalCards[index + 1]?.image['thumbnail'])}
                            tag={normalCards[index + 1]?.tag}
                            domain={normalCards[index + 1]?.domain}
                            price={normalCards[index + 1]?.price}
                            hideTag={false}
                          />
                        </div>
                      )}
                    </div>
                  )
                ))}
              </>
            )}

            <div className="row row1 featured-row featured-row-mobile">
              <div className="card card2 card-mobile">
                <Button variant='primary' onClick={() => {
                  navigateTo('/')
                }} leftIcon={Globe} rightIcon={ArrowRight}>
                  <Typography variant={'button'}>browse all domains</Typography>
                </Button>
                <Button variant='primary-2' onClick={() => {
                  navigateTo('/tool/appraisal')
                }} leftIcon={SearchIcon} rightIcon={ArrowRight}>
                  <Typography variant={'button'}>appraise your domain</Typography>
                </Button>
                <Button variant='primary-2' onClick={() => {
                  navigateTo('/contact')
                }} leftIcon={InfoIcon} rightIcon={ArrowRight}>
                  <Typography variant={'button'}>talk to our team</Typography>
                </Button>
              </div>
            </div>
          </div>
        </div>
        <BlogSection display={'onlyNewsletter'} />
      </div>
    </section>
  );
}



const Step = ({
  side = 'right', // 'left' or 'right'
  icon, // React element
  number = '01',
  title = '',
  description = '',
  showConnector = false
}) => {
  return (
    <div className={`step step-${side}`}>
      <div className='step-content empty'></div>
      <div className="step-idx">
        <div className="step-counter">
          <Typography variant="number">{number}</Typography>
        </div>
        {showConnector && <div className="step-connector"></div>}
      </div>
      <div className="step-content">
        <div className="step-icon">
          {icon}
        </div>
        <div className="step-text">
          <div className="step-title">
            <Typography variant="h2">{title}</Typography>
          </div>
          <div className="step-desc">
            <Typography variant="para">{description}</Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

const SearchIconX = (props) => (
  <svg
    width={30}
    height={30}
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M28 28L14 14"
      stroke="#0077FF"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 24C19.0751 24 24 19.0751 24 13C24 6.92487 19.0751 2 13 2C6.92487 2 2 6.92487 2 13C2 19.0751 6.92487 24 13 24Z"
      fill="white"
      stroke="#0077FF"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const DataIcon = (props) => (
  <svg
    width={40}
    height={40}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.5641 16.0203C17.5121 15.8646 17.4914 15.7001 17.503 15.5364C17.5147 15.3726 17.5584 15.2128 17.6319 15.0659C17.7053 14.9191 17.8069 14.7882 17.9309 14.6806C18.0549 14.573 18.1989 14.491 18.3547 14.4391L20.2297 13.8141C20.4176 13.7514 20.6177 13.7343 20.8135 13.7642C21.0093 13.7941 21.1952 13.8701 21.3559 13.9859C21.5166 14.1017 21.6475 14.254 21.7377 14.4304C21.828 14.6067 21.875 14.8019 21.875 15V21.25C21.875 21.5815 21.7433 21.8995 21.5089 22.1339C21.2745 22.3683 20.9565 22.5 20.625 22.5C20.2935 22.5 19.9755 22.3683 19.7411 22.1339C19.5067 21.8995 19.375 21.5815 19.375 21.25V16.7344L19.1453 16.8109C18.9896 16.8629 18.8251 16.8836 18.6614 16.872C18.4976 16.8603 18.3378 16.8166 18.1909 16.7431C18.0441 16.6697 17.9132 16.5681 17.8056 16.4441C17.698 16.3201 17.616 16.1761 17.5641 16.0203ZM38.75 32.5C38.75 32.8315 38.6183 33.1495 38.3839 33.3839C38.1495 33.6183 37.8315 33.75 37.5 33.75H2.5C2.16848 33.75 1.85054 33.6183 1.61612 33.3839C1.3817 33.1495 1.25 32.8315 1.25 32.5C1.25 32.1685 1.3817 31.8505 1.61612 31.6161C1.85054 31.3817 2.16848 31.25 2.5 31.25H3.75V16.25C3.75 15.587 4.01339 14.9511 4.48223 14.4822C4.95107 14.0134 5.58696 13.75 6.25 13.75H12.5V8.75C12.5 8.08696 12.7634 7.45107 13.2322 6.98223C13.7011 6.51339 14.337 6.25 15 6.25H25C25.663 6.25 26.2989 6.51339 26.7678 6.98223C27.2366 7.45107 27.5 8.08696 27.5 8.75V20H33.75C34.413 20 35.0489 20.2634 35.5178 20.7322C35.9866 21.2011 36.25 21.837 36.25 22.5V31.25H37.5C37.8315 31.25 38.1495 31.3817 38.3839 31.6161C38.6183 31.8505 38.75 32.1685 38.75 32.5ZM27.5 22.5V31.25H33.75V22.5H27.5ZM15 31.25H25V8.75H15V31.25ZM6.25 31.25H12.5V16.25H6.25V31.25Z"
      fill="#0077FF"
    />
  </svg>
);

const MeasureIcon = (props) => (
  <svg
    width={40}
    height={40}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M36.7688 11.4641L28.536 3.2328C28.3038 3.00059 28.0282 2.81639 27.7248 2.69072C27.4215 2.56505 27.0963 2.50037 26.768 2.50037C26.4396 2.50037 26.1145 2.56505 25.8112 2.69072C25.5078 2.81639 25.2322 3.00059 25 3.2328L3.23128 25C2.99907 25.2321 2.81487 25.5078 2.6892 25.8111C2.56352 26.1145 2.49884 26.4396 2.49884 26.768C2.49884 27.0963 2.56352 27.4214 2.6892 27.7248C2.81487 28.0281 2.99907 28.3038 3.23128 28.5359L11.4641 36.7672C11.6962 36.9994 11.9719 37.1836 12.2752 37.3093C12.5786 37.4349 12.9037 37.4996 13.2321 37.4996C13.5604 37.4996 13.8855 37.4349 14.1889 37.3093C14.4922 37.1836 14.7679 36.9994 15 36.7672L36.7688 15C37.001 14.7678 37.1852 14.4922 37.3109 14.1889C37.4365 13.8855 37.5012 13.5604 37.5012 13.232C37.5012 12.9037 37.4365 12.5785 37.3109 12.2752C37.1852 11.9718 37.001 11.6962 36.7688 11.4641ZM13.2313 35L5.00003 26.7672L10 21.7672L14.1157 25.8844C14.2318 26.0005 14.3697 26.0926 14.5214 26.1555C14.6731 26.2183 14.8358 26.2507 15 26.2507C15.1643 26.2507 15.3269 26.2183 15.4786 26.1555C15.6304 26.0926 15.7683 26.0005 15.8844 25.8844C16.0005 25.7682 16.0927 25.6303 16.1555 25.4786C16.2184 25.3269 16.2507 25.1642 16.2507 25C16.2507 24.8357 16.2184 24.6731 16.1555 24.5214C16.0927 24.3696 16.0005 24.2318 15.8844 24.1156L11.7672 20L15 16.7672L19.1157 20.8844C19.3502 21.1189 19.6683 21.2507 20 21.2507C20.3317 21.2507 20.6499 21.1189 20.8844 20.8844C21.119 20.6498 21.2507 20.3317 21.2507 20C21.2507 19.6683 21.119 19.3502 20.8844 19.1156L16.7672 15L20 11.7672L24.1157 15.8844C24.2318 16.0005 24.3697 16.0926 24.5214 16.1555C24.6731 16.2183 24.8358 16.2507 25 16.2507C25.1643 16.2507 25.3269 16.2183 25.4786 16.1555C25.6304 16.0926 25.7683 16.0005 25.8844 15.8844C26.0005 15.7682 26.0927 15.6303 26.1555 15.4786C26.2184 15.3269 26.2507 15.1642 26.2507 15C26.2507 14.8357 26.2184 14.6731 26.1555 14.5214C26.0927 14.3696 26.0005 14.2317 25.8844 14.1156L21.7672 9.99999L26.7672 4.99999L35 13.2328L13.2313 35Z"
      fill="#0077FF"
    />
  </svg>
);

const WhyChooseUs = () => {
  return (


    <div className="highlight-wrapper">
      <div className="inner">
        <div className="highlight-heading-area">
          <Typography variant="h1">Why Choose Us</Typography>
        </div>
        <div className="highlight-content-area">
          <Step
            side="right"
            number="01"
            icon={<SearchIconX />}
            title="Expert Domain Acquisition"
            showConnector={true}
            description="We help you secure even the most hard-to-get domains through strategic outreach and skilled negotiation. Our team knows how to approach domain owners with serious, educated offers."
          />
          <Step
            side="left"
            number="02"
            icon={<DataIcon />}
            title="Discreet & Data-Driven"
            showConnector={true}
            description="We work quietly and professionally, backed by real market data, to avoid overpaying and ensure fair value. Your investment is handled with precision and privacy."
          />
          <Step
            side="right"
            number="03"
            icon={<MeasureIcon />}
            title="Trusted by Industry Leaders"
            description="We broker high-value deals for companies and investors around the world.Our experience ensures confident decisions and strong long-term value."
          />
        </div>
      </div>
    </div>

  );
}


const WorkStep = ({
  side = 'right', // 'left' or 'right'
  icon, // React element
  number = '01',
  title = '',
  description = '',
  showConnector = false,
  content = null,
  success = false,
  extraHeight = '0'
}) => {
  return (
    <div className={`step step-${side} extra-height-${extraHeight}`}>
      <div className="step-idx">
        <div className={success ? "step-counter success" : "step-counter"}>
          {success ? <CheckIcon /> : <Typography variant="number">{number}</Typography>}
        </div>
        {showConnector && <div className="step-connector"></div>}
      </div>
      <div className="step-content">
        <div className="step-text">
          <div className="step-title">
            <Typography variant="h2">{title}</Typography>
          </div>
          <div className="step-desc">
            <Typography variant="para">{description}</Typography>
          </div>
          {content}
        </div>
      </div>
    </div>
  );
};

const HowItWorksSection = () => {
  const appCtx = useApp();

  const navigateTo = useNavigate();

  return (

    <div className="process-wrapper">
      <div className="inner">
        <div className="process-heading-area">
          <Typography variant="h1">How it Works?</Typography>
        </div>
        <div className="process-content-area">
          <WorkStep
            side="right"
            number="1"
            extraHeight={'1'}
            icon={<SearchIcon />}
            title="Find your Domain name."
            showConnector={true}
            content={
              <>
                <div className='featured-domain-list-module'>
                  <div className="inner">
                    <div className='domain-list'>
                      {appCtx.heroDomainsList.slice(0, 3).map((domain, i) => {
                        return (
                          <DomainCard key={`${i}`} image={domain.image['thumbnail']} tag={domain.tag} domain={domain.domain} price={domain.price} hideTag={true} />
                        )
                      })}
                    </div>
                    <div className="domain-button">
                      <Button isLink={true} linkProps={{to:"/domains-for-sale"}} variant="primary-2" leftIcon={Globe} rightIcon={ArrowRight}>
                        <Typography variant={'button'}>Browse our Listing</Typography>
                      </Button>
                    </div>
                  </div>
                </div>
              </>
            }
            description="Browse our curated listings to discover premium domain names across every niche.Can’t find what you’re looking for? Just ask — we’ll help you locate it."
          />
          <WorkStep
            side="left"
            number="2"
            icon={<SearchIcon />}
            title="Make an Offer"
            extraHeight={'2'}
            showConnector={true}
            content={
              <div className='featured-domain-list-module'>
                <div className="inner">
                  <div className="domain-button">
                    <Button isLink={true} linkProps={{to:"/contact"}} variant="primary-2" leftIcon={Globe} rightIcon={ArrowRight}>
                      <Typography variant={'button'}>Fill Inquiry form</Typography>
                    </Button>
                    <Button isLink={true} linkProps={{to:"tel:+19415009689"}} variant="primary-2" leftIcon={Globe} rightIcon={ArrowRight}>
                      <Typography variant={'button'}>Call Us</Typography>
                    </Button>
                    <Button isLink={true} linkProps={{to:"mailto:john@nameconnect.com"}} variant="primary-2" leftIcon={Globe} rightIcon={ArrowRight}>
                      <Typography variant={'button'}>Email Us</Typography>
                    </Button>
                  </div>
                </div>
              </div>
            }
            description={<>Reach out via our inquiry form or email.<br />We’ll guide you through the process and negotiate the best possible deal on your behalf</>}
          />
          <WorkStep
            side="right"
            number="3"
            icon={<SearchIcon />}
            success={true}
            title="Acquire your Dream Domain"
            description="Once the deal is in place, we handle everything to ensure a smooth, secure transfer.You’ll own your perfect domain - ready to power your brand."
          />
        </div>
      </div>
    </div>
  );
}


const Testinomials = () => {

  const appCtx = useApp();
  const navigateTo = useNavigate();

  return (

    <div className="testinomial-wrapper">
      <div className="inner">
        <div className="testinomial-heading">
          <Typography variant="h1">Testimonials</Typography>
        </div>
        <div className="testinomial-content">
          <div className="testinomial-row">
            <div className="tesinomial-info">
              <Typography variant="para">"With over 8 years in business, we have brokered more than 10 seven figure deals, we work quietly and professionally with data-driven to avoid underselling or overpaying ensuring fair value with precision.<br />Explore our tools to get quick value of your domain or find more details about a domain.</Typography>
            </div>
            <div className="testinomial-controls testinomial-controls-pc">
              <Button variant='primary-2' onClick={() => {
                navigateTo('/tool/appraisal')
              }} leftIcon={Globe} rightIcon={ArrowRight}>
                <Typography variant={'button'}>Find your domain value</Typography>
              </Button>
              <Button variant='primary-2' onClick={() => {
                navigateTo('/tool/whois')
              }} leftIcon={SearchIcon} rightIcon={ArrowRight}>
                <Typography variant={'button'}>Find WHOIS information</Typography>
              </Button>
              <Button variant='primary' onClick={() => {
                navigateTo('/contact')
              }} leftIcon={InfoIcon} rightIcon={ArrowRight}>
                <Typography variant={'button'}>Talk to our Team</Typography>
              </Button>
            </div>
          </div>
          <div className="testinomial-row">

            {appCtx.testinomialsList.map((testinomial, i) => {
              return (
                <div className="testinomial-people">
                  <div className="testinomial-people-avatar">
                    <img src={(testinomial.picture || {})['original']} alt="" />
                  </div>
                  <div className="testinomial-people-info">
                    <div className="testinomial-people-name">
                      <Typography variant="para">{testinomial.name}</Typography>
                    </div>
                    <div className="testinomial-people-desc">
                      <Typography variant="para">{testinomial.review}</Typography>
                    </div>
                  </div>
                </div>
              )
            })}

            {/* <div className="testinomial-people">
              <div className="testinomial-people-avatar">
                <img src="https://f.start.me/us.gov" alt="" />
              </div>
              <div className="testinomial-people-info">
                <div className="testinomial-people-name">
                  <Typography variant="para">John Doe</Typography>
                </div>
                <div className="testinomial-people-desc">
                  <Typography variant="para">Mr Daly assisted us in a very substantial and important acquisition for our company. We had attempted contacting the owner of a domain we were interested but had no luck, a week after speaking with John we had a contract in place at the price we wanted and were planning out our Marketing strategy. I would recommend John to anyone serious about their online presence.</Typography>
                </div>
              </div>
            </div>

            <div className="testinomial-people">
              <div className="testinomial-people-avatar">
                <img src="https://f.start.me/us.gov" alt="" />
              </div>
              <div className="testinomial-people-info">
                <div className="testinomial-people-name">
                  <Typography variant="para">John Doe</Typography>
                </div>
                <div className="testinomial-people-desc">
                  <Typography variant="para">Mr Daly assisted us in a very substantial and important acquisition for our company. We had attempted contacting the owner of a domain we were interested but had no luck, a week after speaking with John we had a contract in place at the price we wanted and were planning out our Marketing strategy. I would recommend John to anyone serious about their online presence.</Typography>
                </div>
              </div>
            </div>

            <div className="testinomial-people">
              <div className="testinomial-people-avatar">
                <img src="https://f.start.me/us.gov" alt="" />
              </div>
              <div className="testinomial-people-info">
                <div className="testinomial-people-name">
                  <Typography variant="para">John Doe</Typography>
                </div>
                <div className="testinomial-people-desc">
                  <Typography variant="para">Mr Daly assisted us in a very substantial and important acquisition for our company. We had attempted contacting the owner of a domain we were interested but had no luck, a week after speaking with John we had a contract in place at the price we wanted and were planning out our Marketing strategy. I would recommend John to anyone serious about their online presence.</Typography>
                </div>
              </div>
            </div> */}

            <div className="testinomial-controls testinomial-controls-mobile mt-4">
              <Button variant='primary-2' leftIcon={Globe} rightIcon={ArrowRight}>
                <Typography variant={'button'}>Find your domain value</Typography>
              </Button>
              <Button variant='primary-2' leftIcon={SearchIcon} rightIcon={ArrowRight}>
                <Typography variant={'button'}>Find WHOIS information</Typography>
              </Button>
              <Button variant='primary' leftIcon={InfoIcon} rightIcon={ArrowRight}>
                <Typography variant={'button'}>Talk to our Team</Typography>
              </Button>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}


const feaured_domains_list = [
  {
    image: "/images/domains/detoxaid_com.png",
    tag: "Lifestyle",
    domain: "detoxaid.com",
    price: "1299"
  },
  {
    image: "/images/domains/detoxaid_com.png",
    tag: "Lifestyle",
    domain: "detoxaid.com",
    price: "1299"
  },
  {
    image: "/images/domains/detoxaid_com.png",
    tag: "Lifestyle",
    domain: "detoxaid.com",
    price: "1299"
  },
  {
    image: "/images/domains/detoxaid_com.png",
    tag: "Lifestyle",
    domain: "detoxaid.com",
    price: "1299"
  },
  {
    image: "/images/domains/detoxaid_com.png",
    tag: "Lifestyle",
    domain: "detoxaid.com",
    price: "1299"
  },
  {
    image: "/images/domains/detoxaid_com.png",
    tag: "Lifestyle",
    domain: "detoxaid.com",
    price: "1299"
  }
]


/**
 * Home page component with feed
 * @returns {JSX.Element} Home page component
 */
const Home = () => {



  return (
    <>
      <Hero />
      <FeaturedSection />
      <WhyChooseUs />
      <HowItWorksSection />
      <Testinomials />
      <ContactSection />
      <BlogSection display={'onlyBlog'} />
    </>
  );
};

export default Home;